import { Entity } from '../entity';
import { Lex } from '../shared/lexorank';
import { OpportunityViewFilters } from './opportunity.filters';

export enum OpportunityViewVisibility {
    Private = 'Private',
    Public = 'Public',
    Shared = 'Shared'
}

export enum OpportunitySystemViewName {
    MyDeals = 'My Deals',
    // Open = 'Open Deals',
    // ClosingThisMonth = 'Closing This Month',
    // ClosingNextMonth = 'Closing Next Month',
    // NewThisWeek = 'New This Week',
    // NewLastWeek = 'New Last Week',
    // All = 'All Deals'
}

export enum OpportunityViewDisplayType {
    Kanban = 'Kanban',
    Grid = 'Grid'
}

export type OpportunityViewSortType = 'ASC' | 'DESC';

export enum OpportunityViewSortBy {
    None = 'none',
    Name = 'name',
    Amount = 'amount',
    CreatedDate = 'createdAt',
    LastActivityDate = 'sorting.lastActivity',
    ExpectedCloseDate = 'sorting.expectedClose',
}

export interface OpportunityViewSortOptions {
    sortBy: OpportunityViewSortBy;
    sortType: OpportunityViewSortType;
}

export interface OpportunityViewHighlightRule {
    fieldName: OpportunityViewSortBy;
    days?: number;
}

export interface OpportunityViewSummary {
    _id: string;
    name: string;
    visibility: OpportunityViewVisibility;
    displayType: OpportunityViewDisplayType;
    sort?: OpportunityViewSortOptions;
    card: OpportunityViewCardFields,
    list: OpportunityViewListField[];
    isDefault: boolean;
    system: boolean;
    selected: boolean;
    ownerId?: string;
    canEditView?: boolean;
    sharedWith: Entity[]
    filters?: OpportunityViewFilters;
    highlightRule?: OpportunityViewHighlightRule;
}

export interface OpportunityViewCardFields {
    name: boolean;
    amount: boolean;
    customer: boolean;
    owner: boolean;
    closeDate: boolean;
    source: boolean;
    jobType: boolean;
    tags: boolean;
    contact: boolean;
    address: boolean;
    createdAt: boolean;
    zones: boolean;
    company: boolean;
    age: boolean;

    customFields: Entity[];
}

export interface OpportunityViewListField {
    _id: string;
    name: string;
    visible: boolean;
    sortOrder: Lex;
    system: boolean;
}


export const DefaultOpportunityFields = [
    { _id: 'opportunityNumber', name: 'Opportunity Number', visible: true, system: true },
    { _id: 'name', name: 'Name', visible: true, system: true },
    { _id: 'account', name: 'Customers', visible: true, system: true },
    { _id: 'stage', name: 'Stage', visible: true, system: true },
    { _id: 'probability', name: 'Probability', visible: true, system: true },
    { _id: 'contact', name: 'Contact', visible: true, system: true },
    { _id: 'siteName', name: 'Site', visible: true, system: true },
    { _id: 'address', name: 'Address', visible: true, system: true },
    { _id: 'amount', name: 'Estimated Amount', visible: true, system: true },
    { _id: 'owner', name: 'Owner', visible: true, system: true },
    { _id: 'closeDate', name: 'Expected Close Date', visible: true, system: true },
    { _id: 'source', name: 'Source', visible: true, system: true },
    { _id: 'jobType', name: 'Job Type', visible: true, system: true },
    { _id: 'tags', name: 'Tags', visible: true, system: true },
    { _id: 'createdAt', name: 'Created Date', visible: false, system: true },
    { _id: 'zones', name: 'Zones', visible: false, system: true },
    { _id: 'company', name: 'Company', visible: false, system: true },
    { _id: 'age', name: 'Age', visible: false, system: true },
] as OpportunityViewListField[];

export interface OpportunityView extends Entity {

    description: string;
    displayType?: OpportunityViewDisplayType;
    visibility?: OpportunityViewVisibility;
    sharedWith?: Entity[];

    owner: Entity;
    system?: boolean;

    filters: OpportunityViewFilters;
    card: OpportunityViewCardFields;
    list: OpportunityViewListField[];

    canEditView?: boolean;
    canShareView?: boolean;

    sort?: OpportunityViewSortOptions;
    highlightRule?: OpportunityViewHighlightRule;
}

export const OpportunityViewCardDefaults = {
    name: true,
    amount: true,
    customer: true,
    owner: true,
    closeDate: true,
    customFields: [],
    jobType: true,
    source: true,
    tags: true,
    createdAt: false,
    age: false,
};

export function emptyOpportunityView(data?: Partial<OpportunityView>) {
    return {
        name: null,
        description: null,
        displayType: OpportunityViewDisplayType.Kanban,
        visibility: OpportunityViewVisibility.Private,
        sharedWith: [],
        filters: {},
        card: { ...OpportunityViewCardDefaults },
        list: [...DefaultOpportunityFields],
        ...data,
    } as OpportunityView;
}